import { useState } from 'react'
import { Dropdown } from '@/React/Shared/Component/Dropdown'
import { DropdownItem } from '@/React/Shared/Component/DropdownItem'
import { Icon, IconNameEnum } from '@/React/Shared/Component/Icon'
import { CountryFlag } from '@/React/Shared/Component/CountryFlag'
import useQueryParams from '@/Shared/Hook/useQueryParams'
import {
    LocaleEnumList,
    type LocaleEnum,
    type LocaleEnumDataEntry,
} from '@/Shared/AutoGenerated/LocalizationEnum'

export interface LocaleDropdownProps {
    currentLocaleEnumData: LocaleEnumDataEntry
    className?: string
}

export function LocaleDropdown({
    currentLocaleEnumData,
    className = '',
}: LocaleDropdownProps) {
    const [isOpen, setIsOpen] = useState(false)

    const getUrl = (locale: LocaleEnum): string => {
        if (typeof window === 'undefined') {
            return `?locale=${locale}`
        }
        return useQueryParams().replace([{ key: 'locale', value: locale }])
    }

    return (
        <Dropdown
            show={isOpen}
            horizontalPosition="left"
            verticalPosition="top"
            onClose={() => setIsOpen(false)}
            className={className}
        >
            <Dropdown.Trigger>
                <button
                    type="button"
                    aria-haspopup="true"
                    aria-expanded={isOpen}
                    aria-label={`Select language, current: ${currentLocaleEnumData.nativeLanguageLabel}`}
                    onClick={() => setIsOpen((prev) => !prev)}
                    className="p-2 border border-gray-200 rounded-xl flex items-center gap-3 cursor-pointer bg-white text-gray-800 hover:bg-gray-50 focus-visible:ring-2 focus-visible:ring-primary focus-visible:outline-none"
                >
                    <CountryFlag
                        className="size-4"
                        locale={currentLocaleEnumData.key}
                        aria-hidden="true"
                    />
                    <span>{currentLocaleEnumData.nativeLanguageLabel}</span>
                    <Icon
                        name={IconNameEnum.AngleDown}
                        className="w-3.5 h-3.5 text-gray-500"
                        aria-hidden="true"
                    />
                </button>
            </Dropdown.Trigger>
            <Dropdown.Menu>
                <div>
                    {LocaleEnumList.map((locale) => (
                        <DropdownItem
                            key={locale.key}
                            href={getUrl(locale.key)}
                        >
                            <div className="flex items-center gap-2">
                                <CountryFlag
                                    className="size-4"
                                    locale={locale.key}
                                    aria-hidden="true"
                                />
                                <span>{locale.nativeLanguageLabel}</span>
                            </div>
                        </DropdownItem>
                    ))}
                </div>
            </Dropdown.Menu>
        </Dropdown>
    )
}
